// Document editor interface text only. Personal values are never translated.
export default {
  "No document copies are currently available.": {
    "es": "No hay copias de documentos disponibles actualmente.",
    "ko": "현재 사용할 수 있는 문서 사본이 없습니다."
  },
  "Admin fixed value": {
    "es": "Valor fijado por Admin",
    "ko": "Admin 고정값"
  },
  "Answers changed. Review and draw the signatures again.": {
    "es": "Las respuestas han cambiado. Revise el documento y vuelva a dibujar las firmas.",
    "ko": "답변이 변경되었습니다. 문서를 검토하고 다시 서명해 주세요."
  },
  "Clear": {
    "es": "Borrar",
    "ko": "지우기"
  },
  "Click or tap to sign": {
    "es": "Haga clic o toque para firmar",
    "ko": "클릭하거나 눌러 서명"
  },
  "Could not display this page. Please reload the document.": {
    "es": "No se pudo mostrar esta página. Vuelva a cargar el documento.",
    "ko": "페이지를 표시하지 못했습니다. 문서를 다시 불러오세요."
  },
  "Could not download the document. Please retry.": {
    "es": "No se pudo descargar el documento. Inténtelo de nuevo.",
    "ko": "문서를 다운로드하지 못했습니다. 다시 시도하세요."
  },
  "Could not load document copies. Please retry.": {
    "es": "No se pudieron cargar las copias de los documentos. Inténtelo de nuevo.",
    "ko": "문서 사본을 불러오지 못했습니다. 다시 시도해 주세요."
  },
  "Could not open the document. Please retry.": {
    "es": "No se pudo abrir el documento. Inténtelo de nuevo.",
    "ko": "문서를 열지 못했습니다. 다시 시도하세요."
  },
  "Could not save the document. Please retry.": {
    "es": "No se pudo guardar el documento. Inténtelo de nuevo.",
    "ko": "문서를 저장하지 못했습니다. 다시 시도하세요."
  },
  "Document Editor": {
    "es": "Editor de documentos",
    "ko": "문서 편집기"
  },
  "Document copies": {
    "es": "Copias de documentos",
    "ko": "문서 사본"
  },
  "Document copy saved": {
    "es": "Copia del documento guardada",
    "ko": "문서 사본 저장됨"
  },
  "Done": {
    "es": "Listo",
    "ko": "완료"
  },
  "Draw in the selected signature box. Zoom in for more room.": {
    "es": "Dibuje en el recuadro de firma seleccionado. Acerque la vista para tener más espacio.",
    "ko": "선택한 서명 칸에 그려 주세요. 확대하면 더 넓게 서명할 수 있습니다."
  },
  "Draw signature": {
    "es": "Dibujar firma",
    "ko": "서명 그리기"
  },
  "Edit fields on this page": {
    "es": "Editar los campos de esta página",
    "ko": "이 페이지의 항목 편집"
  },
  "Editable document copies": {
    "es": "Copias de documentos editables",
    "ko": "편집 가능한 문서 사본"
  },
  "Fit width": {
    "es": "Ajustar al ancho",
    "ko": "너비에 맞추기"
  },
  "How to complete this document": {
    "es": "Cómo completar este documento",
    "ko": "문서 작성 방법"
  },
  "I reviewed this document and intend this drawing as my signature. I am authorized to sign the selected role.": {
    "es": "He revisado este documento y deseo utilizar este dibujo como mi firma. Tengo autorización para firmar en el rol seleccionado.",
    "ko": "이 문서를 검토했으며, 이 그림을 본인의 서명으로 사용하려고 합니다. 선택한 역할로 서명할 권한이 있습니다."
  },
  "Keep editing": {
    "es": "Seguir editando",
    "ko": "계속 편집"
  },
  "Leave": {
    "es": "Salir",
    "ko": "나가기"
  },
  "Leave without saving your document changes?": {
    "es": "¿Desea salir sin guardar los cambios del documento?",
    "ko": "문서 변경 사항을 저장하지 않고 나가시겠습니까?"
  },
  "Loading documents...": {
    "es": "Cargando documentos...",
    "ko": "문서를 불러오는 중..."
  },
  "Loading page...": {
    "es": "Cargando la página...",
    "ko": "페이지 불러오는 중..."
  },
  "Next page": {
    "es": "Página siguiente",
    "ko": "다음 페이지"
  },
  "Not selected": {
    "es": "Sin seleccionar",
    "ko": "선택 안 함"
  },
  "Open / Edit": {
    "es": "Abrir / Editar",
    "ko": "열기 / 편집"
  },
  "Open your own copy to review, edit and sign. Admin template values stay locked.": {
    "es": "Abra su propia copia para revisarla, editarla y firmarla. Los valores de la plantilla fijados por Admin permanecen bloqueados.",
    "ko": "본인 사본을 열어 검토·편집·서명하세요. Admin이 지정한 템플릿 값은 변경할 수 없습니다."
  },
  "Pen": {
    "es": "Bolígrafo",
    "ko": "펜"
  },
  "Pencil": {
    "es": "Lápiz",
    "ko": "연필"
  },
  "Prefilled draft": {
    "es": "Borrador con datos completados",
    "ko": "자동입력된 초안"
  },
  "Preparing document...": {
    "es": "Preparando el documento...",
    "ko": "문서 준비 중..."
  },
  "Previous page": {
    "es": "Página anterior",
    "ko": "이전 페이지"
  },
  "Reload document": {
    "es": "Volver a cargar el documento",
    "ko": "문서 다시 불러오기"
  },
  "Review every page. Edit your own copy, then draw only in signature boxes enabled for you. Editing answers clears the drawn signatures so you can review and sign again. Save and download your copy. Saving does not submit, approve or file it.": {
    "es": "Revise todas las páginas. Edite su propia copia y dibuje únicamente en los recuadros de firma habilitados para usted. Al editar las respuestas, se borran las firmas dibujadas para que pueda revisar y firmar de nuevo. Guarde y descargue su copia. Guardarla no la envía, aprueba ni presenta ante ninguna entidad.",
    "ko": "모든 페이지를 검토하세요. 본인 사본을 편집한 뒤, 본인에게 허용된 서명 칸에만 서명하세요. 답변을 수정하면 그린 서명이 지워지므로, 다시 검토하고 서명해야 합니다. 사본을 저장하고 다운로드하세요. 저장만으로 제출·승인·신고가 이루어지지는 않습니다."
  },
  "Save copy": {
    "es": "Guardar copia",
    "ko": "사본 저장"
  },
  "Select...": {
    "es": "Seleccione...",
    "ko": "선택..."
  },
  "Signature tools": {
    "es": "Herramientas de firma",
    "ko": "서명 도구"
  },
  "Size": {
    "es": "Grosor",
    "ko": "굵기"
  },
  "Some signatures require a different signing method. Print and sign those sections or follow the form instructions.": {
    "es": "Algunas firmas requieren un método de firma distinto. Imprima y firme esas secciones o siga las instrucciones del formulario.",
    "ko": "일부 서명은 다른 서명 방식이 필요합니다. 해당 부분은 인쇄하여 서명하거나 양식의 안내를 따라 주세요."
  },
  "Support login": {
    "es": "Acceso de soporte",
    "ko": "지원 로그인"
  },
  "The document or saved information changed. Reload before saving.": {
    "es": "El documento o los datos guardados han cambiado. Vuelva a cargarlo antes de guardar.",
    "ko": "문서 또는 저장된 정보가 변경되었습니다. 다시 불러온 후 저장하세요."
  },
  "This signature must be completed by the authorized signer using the required signing method.": {
    "es": "Esta firma debe realizarla la persona autorizada mediante el método de firma requerido.",
    "ko": "이 서명은 권한이 있는 서명자가 해당 양식에서 요구하는 방식으로 작성해야 합니다."
  },
  "This signature will be recorded as a support login.": {
    "es": "Esta firma se registrará como realizada mediante un acceso de soporte.",
    "ko": "이 서명은 지원 로그인에서 작성한 것으로 기록됩니다."
  },
  "Tool": {
    "es": "Herramienta",
    "ko": "도구"
  },
  "Unsaved changes": {
    "es": "Cambios sin guardar",
    "ko": "저장하지 않은 변경 사항"
  },
  "You can edit your information in this document copy. Admin template values are locked. Your profile and the original template stay unchanged.": {
    "es": "Puede editar su información en esta copia del documento. Los valores fijados por Admin están bloqueados. Su perfil y la plantilla original no se modifican.",
    "ko": "이 문서 사본에서 본인 정보를 수정할 수 있습니다. Admin 고정값은 변경할 수 없으며, 프로필과 원본 템플릿에는 반영되지 않습니다."
  },
  "Your account changed. Reopen the document from your current account.": {
    "es": "Su cuenta ha cambiado. Vuelva a abrir el documento desde su cuenta actual.",
    "ko": "계정이 변경되었습니다. 현재 계정에서 문서를 다시 열어 주세요."
  },
  "Zoom in": {
    "es": "Acercar",
    "ko": "확대"
  },
  "Zoom out": {
    "es": "Alejar",
    "ko": "축소"
  },
  "Client documents": {
    "es": "Documentos del cliente",
    "ko": "Client 문서"
  },
  "Select a client to view their documents": {
    "es": "Seleccione un cliente para ver sus documentos",
    "ko": "문서를 확인할 Client를 선택하세요"
  },
  "W-9 is available in the Vendor portal.": {
    "es": "El formulario W-9 está disponible en el portal de Vendor.",
    "ko": "W-9은 Vendor 포털에서 사용할 수 있습니다."
  },
  "This document is not available for this enrollment.": {
    "es": "Este documento no está disponible para esta inscripción.",
    "ko": "이 등록 건에서는 해당 문서를 사용할 수 없습니다."
  },
  "Saved drawn signature": {
    "es": "Firma dibujada guardada",
    "ko": "저장된 그리기 서명"
  },
  "Your saved information changed. Previous signatures are kept in the document history. Review this copy and sign again.": {
    "es": "Su información guardada ha cambiado. Las firmas anteriores se conservan en el historial del documento. Revise esta copia y vuelva a firmar.",
    "ko": "저장된 정보가 변경되었습니다. 이전 서명은 문서 이력에 보관됩니다. 이 사본을 검토한 뒤 다시 서명해 주세요."
  }
};
